import { listGroups, RosterGroup } from 'app/api/roster';
import { SessionAppState } from 'app/dux/session';
import { getDelegatedOrCurrentCompanyId } from 'app/dux/session/selectors';
import { keyBy } from 'lodash';
import { Dispatch } from 'redux';
import { CompanyAction, CompanyMap, withCompany } from 'utils/companyDux';

export interface GroupsState {
    groupsById?: { [groupId: string]: RosterGroup | undefined };
}

export interface GroupsAppState {
    groups: CompanyMap<GroupsState>;
}

type RelevantAppState = GroupsAppState & SessionAppState;

enum ActionTypes {
    GROUPS_LOADED = 'GROUPS_LOADED',
}

interface GroupsLoadedAction extends CompanyAction<ActionTypes.GROUPS_LOADED> { groups: RosterGroup[] }

type GroupsAction = GroupsLoadedAction;

export const groupsReducer = withCompany((state: GroupsState = {}, action: GroupsAction): GroupsState => {
    switch (action.type) {
        case ActionTypes.GROUPS_LOADED: {
            return {
                groupsById: keyBy(action.groups, group => group.id),
            };
        }
    }
    return state;
});

export const loadGroups = () =>
    async (dispatch: Dispatch<GroupsAction>, getState: () => RelevantAppState) => {
        const state = getState();
        const companyId = getDelegatedOrCurrentCompanyId(state);
        const groups = (await listGroups()).data;
        dispatch({ type: ActionTypes.GROUPS_LOADED, companyId, groups });
    };

export const getGroupsState = (state: RelevantAppState) => state.groups[getDelegatedOrCurrentCompanyId(state)] ?? {};

export const getGroupById = (groupId: string) => (state: RelevantAppState): RosterGroup | undefined =>
    getGroupsState(state).groupsById?.[groupId];
